module.exports = __webpack_public_path__ + "static/img/phone-UY.563a332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-UY.png
// module id = tY7Y
// module chunks = 1